import { Component, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material';
import {takeWhile, finalize} from 'rxjs/operators';

import {ApiService} from '../shared/api.service';
import {AssignmentsService} from '../shared/assignments.service';
import {Assignment} from './assignment.model';
import {NotificationService} from '../shared/notification.service';
import {TeamService} from '../shared/team.service';

@Component({
    selector: 'assignment-create',
    templateUrl: 'assignment-create.component.html'
})
export class AssignmentComponent {
    assignment;
    comments = [];
    errors = [];
    messages = [];
    disabled = false;
    pageTitle = 'Create Assignment';
    userId;

    @ViewChild('notes') notes;

    constructor(
        private api: ApiService, 
        private assignments: AssignmentsService, 
        private notifyService: NotificationService, 
        private route: ActivatedRoute, 
        private router: Router,
        public snackBar: MatSnackBar,
        private teamService: TeamService
    ) {
        this.assignment = new Assignment({});
        this.userId = api.getProp('currentUserId');
        this.route.data.subscribe((data) => {
            if( data.state == 'assignment/create/quiz' ) {
                this.pageTitle = 'Create Quiz';
                this.assignment.childType = 'quiz';
                this.assignment.quizType = 'normal';
                this.assignment.outro = true;
            }
        });
        this.teamService.loadTeam(this.assignment);
    }
    submit(callback) {
        this.disabled = true;
        if( this.assignment.writer != 0 ) {
            this.assignment.status = 'assigned';
        }
        this.api.doAction('post', 'assignments', {
            action: 'update',
            assignment: this.assignment
        })
        .pipe(
            takeWhile(val => this.assignment !== null),
            finalize(() => {
                this.disabled = false;
            })
        )
        .subscribe(
            data => {
                this.snackBar.open('Assignment created!', 'Close', {duration: 2000});
                let assignment = new Assignment(data);
                if( this.assignment.status == 'assigned' ) {
                    this.notifyService.statusUpdate('unassigned', 'assigned', assignment);
                }
                this.assignments.add(assignment);
                (() => this.addComments(data.id))();
                if( callback ) {
                    this.notes.resetComments();
                    this[callback]();
                } else {
                    this.router.navigate(['assignments']);
                }
            },
            err => {
                if( err.hasOwnProperty('errors') ) {
                    this.errors = err.errors;
                } else {
                    this.errors = ['An unknown error occurred. Please try again.'];
                }
                throw err;
            }
        );
    }
    newAssignment() {
        let newAssignment = new Assignment({});
        this.assignment = newAssignment;
        this.teamService.loadTeam(this.assignment);
    }
    copyAssignment() {
        let assignment = this.assignment;
        let newAssignment = new Assignment({});
        let noCopy = ['id', 'title', 'notes', 'reference'];
        for(var prop in newAssignment) {
            if( noCopy.indexOf(prop) === -1 ) {
                newAssignment[prop] = assignment[prop];
            }
        }
        this.assignment = newAssignment;
    }
    addComment(comments) {
        this.comments = comments;
    }
    addComments(id) {
        let comments = this.comments;
        let len = this.comments.length;
        for(var i = 0; i < len; i++) {
            let comment = comments[i];
            comment.post = id;
            this.api.doAction('post', 'comment', {
                action: 'create',
                comment: comment
            }).subscribe();
        }
    }
    maybeShowMessage() {
        const team = this.assignment.team;
        const blog_ids = this.assignment.sites.map(item => item.blog_id);
        const sites = this.api.getProp('sites');
        this.messages = [];
        for(var i = 0; i < team.length; i++) {
            const member = team[i];
            const member_blogs = member.limited;
            if( member_blogs.length > 0 ) {
                let memberNeedsBlog = true;
                for(var j = 0; j < blog_ids.length; j++) {
                    if( member_blogs.indexOf(blog_ids[j]) !== -1 ) {
                        memberNeedsBlog = false;
                        break;
                    }
                }
                if( memberNeedsBlog ) {
                    const domains = sites.filter(item => member_blogs.indexOf(item.blog_id) !== -1).map(item => item.domain);
                    this.messages.push(member.name + ' needs ' + domains.join(' or ') + ' for access to this assignment');
                }
            }
        }
    }
    propertiesUpdate(assignment) {
        this.maybeShowMessage();
    }
    teamUpdate(e, assignment) {
        this.teamService.updateAssignment(e, assignment);
        this.maybeShowMessage();
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/assignments/assignment-create.component.ts